import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useUpload } from "../../context/UploadContext";
import { useAutoUpload } from "../../context/AutoUploadContext";
import WatermarkSettingsModal from "../common/WatermarkSettingsModal";
import { checkCompanion, _resetCompanionStatus } from "../../services/videoCompressionService";

const navItems = [
  { label: "Dashboard", path: "/dashboard", icon: "📊" },
  { label: "Events", path: "/events", icon: "🎉" },
  { label: "@Room", path: "/rooms", icon: "💬" },
  { label: "Studio App", path: "/companion", icon: "🖥️" },
  // { label: "Gallery", path: "/gallery", icon: "🖼️" },
  // { label: "Upload Media", path: "/upload", icon: "📤" },
];

const Sidebar = () => {
  const { hasActiveUploads, activeSessionCount, sessions } = useUpload();
  const { activeJobCount } = useAutoUpload();
  const hasAnySessions = Object.keys(sessions).length > 0;
  const [showWatermark, setShowWatermark] = useState(false);
  const [studioOnline, setStudioOnline] = useState(null); // null = unknown

  useEffect(() => {
    let cancelled = false;
    const poll = async () => {
      _resetCompanionStatus();
      const ok = await checkCompanion();
      if (!cancelled) setStudioOnline(ok);
    };
    poll();
    const id = setInterval(poll, 10_000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  return (
    <aside style={styles.sidebar}>
      <div style={styles.navSection}>
        <span style={styles.sectionLabel}>MENU</span>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            style={({ isActive }) => ({
              ...styles.link,
              ...(isActive ? styles.activeLink : {}),
            })}
          >
            <span style={styles.icon}>{item.icon}</span>
            <span>{item.label}</span>
            {item.path === "/companion" && (
              <span
                title={studioOnline === null ? "Checking…" : studioOnline ? "Studio is running" : "Studio is not running"}
                style={{
                  marginLeft: "auto",
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: studioOnline === null ? "#6b7280" : studioOnline ? "#22c55e" : "#ef4444",
                  flexShrink: 0,
                }}
              />
            )}
          </NavLink>
        ))}
        <NavLink
          to="/auto-upload"
          style={({ isActive }) => ({
            ...styles.link,
            ...(isActive ? styles.activeLink : {}),
          })}
        >
          <span style={styles.icon}>🔄</span>
          <span>Auto Upload</span>
          {activeJobCount > 0 && (
            <span style={styles.uploadBadge}>{activeJobCount}</span>
          )}
        </NavLink>
        {hasAnySessions && (
          <NavLink
            to="/uploads"
            style={({ isActive }) => ({
              ...styles.link,
              ...styles.uploadLink,
              ...(isActive ? styles.activeLink : {}),
            })}
          >
            <span style={styles.icon}>
              <span style={hasActiveUploads ? styles.uploadPulse : undefined}>📤</span>
            </span>
            <span>Uploads</span>
            {activeSessionCount > 0 && (
              <span style={styles.uploadBadge}>{activeSessionCount}</span>
            )}
          </NavLink>
        )}

        {/* ── Settings section ── */}
        <span style={{ ...styles.sectionLabel, marginTop: 12 }}>SETTINGS</span>
        <button style={{ ...styles.link, background: "none", border: "none", cursor: "pointer", width: "100%", textAlign: "left" }} onClick={() => setShowWatermark(true)}>
          <span style={styles.icon}>🔏</span>
          <span>Watermark</span>
        </button>
      </div>

      {showWatermark && (
        <WatermarkSettingsModal
          onClose={() => setShowWatermark(false)}
          onSaved={() => {}}
        />
      )}
    </aside>
  );
};

const styles = {
  sidebar: {
    width: 230,
    minHeight: "calc(100vh - 56px)",
    background: "#1e1e2d",
    paddingTop: 8,
    display: "flex",
    flexDirection: "column",
    borderRight: "1px solid rgba(255,255,255,0.04)",
  },
  navSection: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: "8px 0",
  },
  sectionLabel: {
    fontSize: 10,
    fontWeight: 700,
    color: "#6b7280",
    letterSpacing: 1.2,
    padding: "10px 24px 8px",
    textTransform: "uppercase",
  },
  link: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "11px 24px",
    color: "#9ca3af",
    textDecoration: "none",
    fontSize: 13.5,
    fontWeight: 500,
    borderLeft: "3px solid transparent",
    transition: "all 0.15s ease",
  },
  activeLink: {
    color: "#fff",
    background: "rgba(108,99,255,0.12)",
    borderLeft: "3px solid #6c63ff",
  },
  icon: { fontSize: 16, width: 20, textAlign: "center" },
  uploadLink: {
    borderTop: "1px solid rgba(255,255,255,0.06)",
    marginTop: 4,
  },
  uploadPulse: {
    display: "inline-block",
    animation: "pulse 1.5s infinite",
  },
  uploadBadge: {
    marginLeft: "auto",
    background: "#6c63ff",
    color: "#fff",
    fontSize: 10,
    fontWeight: 700,
    padding: "2px 7px",
    borderRadius: 10,
    lineHeight: "14px",
  },
};

export default Sidebar;
